

import { ResizeHandler } from "./helpers";

const resizeHandler = new ResizeHandler();
jQuery(document).ready(function ($) {
    function footerPostGridSlickInit() {
        if(!$('.explore-grid-outer > .wp-block-post-template').hasClass('slick-initialized')) {
          $('.explore-grid-outer > .wp-block-post-template').slick({
              dots: false,
              infinite: false,
              speed: 300,
              slidesToShow: 4,
              slidesToScroll: 4,
              mobileFirst: true,
              responsive: [
              {
                  breakpoint: 991,
                  settings: "unslick"
              },
                {
                  breakpoint: 600,
                  settings: {
                  //   infinite: true,
                    slidesToShow: 2.5,
                    slidesToScroll: 1
                  }
              },
              {
                  breakpoint: 300,
                  settings: {
                  //   infinite: true,
                    slidesToShow: 1.2,
                    slidesToScroll: 1
                  }
                },
              ]
          });
        }
    }
    footerPostGridSlickInit()
    
    resizeHandler.addFunction(footerPostGridSlickInit)
    
    //Meet Our Stars   
    if($('.meet-our-stars .wp-block-post-template').length > 0) {
        $('.meet-our-stars .wp-block-post-template').slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                    //   infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                    //   infinite: true,
                        slidesToShow: 2.5,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 450,
                    settings: {
                    //   infinite: true,
                        slidesToShow: 1.5,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                    //   infinite: true,
                        slidesToShow: 1.2,
                        slidesToScroll: 1
                    }
                },
            ]
        });
    }

    // Affiliate Logos 
    if ( $('.affiliate-logos').length > 0 ) {
        $('.affiliate-logos').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1, 
                        dots: false,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        dots: true,
                        slidesToShow: 3,
                        slidesToScroll: 1, 
                    }
                },
                {
                    breakpoint: 300,
                    settings: {
                        autoplay: true,
                        autoplaySpeed: 2000,
                        dots: false,
                        slidesToShow: 3,
                        slidesToScroll: 1, 
                    }
                }, 
            ]
        }); 
    }
    
})
